import { motion } from 'framer-motion'
import parse from 'html-react-parser'
import React from 'react'
// import ReactGA from 'react-ga'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import { getAnimationFourParams } from '../../../helpers/animations'
import { getSelections } from '../../../store/selections/selectors'
import { Button } from '../../UI/Button/Button'
import { Table } from '../../UI/Table/Table'
import styles from './CollectionBanner.module.scss'
import { CollectionBannerType } from './CollectionBannerType'

export const CollectionBanner = ({
  title,
  lead,
  img,
  id,
  table = false,
  buttonContent = 'Интересно',
  color,
  metro,
  currentPage,
}: CollectionBannerType) => {
  const navigate = useNavigate()
  const selections: any = useSelector(getSelections)

  const bannerArticleAnalytic = () => {
    ym('reachGoal', 'collection click', {
      'article collection click': {
        [`Со статьи ${currentPage}`]: `Подборка ${id}`,
      },
    })
  }

  const handleAnalyticClick = () => {
    bannerArticleAnalytic()
    navigate(`/collections/${id}`)
  }

  return (
    <motion.div
      {...getAnimationFourParams}
      className={styles.apartmentsWrapper}
      id={`#collection-${id}`}
    >
      <div className={styles.investmentsBlock} style={{ background: color }}>
        <img className={styles.investmentsImg} src={img} alt={title} />
        <div className={styles.investmentsDescription}>
          <h3>{parse(title)}</h3>
          <p>{parse(lead)}</p>
          <Button
            content={buttonContent}
            arrowRight
            onClick={handleAnalyticClick}
          />
        </div>
      </div>
      {table && (
        <Table
          items={selections[id]?.items}
          position='bottom'
          isFirstSelection={metro}
          SelectionId={id}
        />
      )}
    </motion.div>
  )
}
